// extracted by mini-css-extract-plugin
export var icon = "_br-3";
export var subtitle = "_br-2";
export var title = "_br-1";
export var value = "_br-0";